import * as React from 'react';

import './popup.contacts.style.scss';

import type { PopupContactsProps } from './popup.contacts.props';

const PopupContacts: React.FC<PopupContactsProps> = function(props) {
  const { contacts } = props;

  if (!contacts?.length) {
    return null;
  }

  return (
    <div className={'contacts'}>
      {contacts.map((contact, key) => {
        const { type } = contact;

        const rel = ['noopener'];

        if (contact.nofollow) {
          rel.push('nofollow');
        }

        if (contact.noindex) {
          rel.push('noindex');
        }

        if (contact.noreferrer) {
          rel.push('noreferrer');
        }

        switch (type) {
          case 'email':
            return (
              <a
                href={`mailto:${contact.label.replace(/^mailto:/, '')}`}
                key={key}
              >{contact.label.replace(/^mailto:/, '')}</a>
            );

          case 'phone':
            return (
              <a
                href={`tel:${contact.label.replace(/[^\d+]/g, '')}`}
                key={key}
              >{contact.label}</a>
            );

          case 'site':
            return (
              <a
                href={contact.label.replace(/\/$/, '')}
                key={key}
                rel={rel.join(' ')}
                target={'_blank'}
              >{contact.label
                .replace(/^https?:\/\//, '')
                .replace(/\/$/, '')
              }</a>
            );

          default:
            console.warn(`Unknown contact type: ${type}`);

            return null;
        }
      })}
    </div>
  );
};

export default PopupContacts;